import { render, staticRenderFns } from "./vertical-table.vue?vue&type=template&id=d54badd4&"
import script from "./vertical-table.vue?vue&type=script&lang=js&"
export * from "./vertical-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports